import {geofenceType} from '../constants/geofence-type.constant';

export const mapPane = {
  REGION: 'region',
  TRACK: 'track',
  GEOPOINT: 'geopoint',
  MARKER: 'marker',
  RIDE_ALLOW: geofenceType.RIDE_ALLOW,
  FINISH_ALLOW: geofenceType.FINISH_ALLOW,
  FINISH_RESTRICT: geofenceType.FINISH_RESTRICT,
  RIDE_RESTRICT: geofenceType.RIDE_RESTRICT,
  SPEED_LIMIT: geofenceType.SPEED_LIMIT,
  TECH_WORK_AREA: geofenceType.TECH_WORK_AREA,
  DEMAND: geofenceType.DEMAND,
  PRIORITY_LAYER: 'priority',
};

export type MapPane = typeof mapPane[keyof typeof mapPane];
